'use client';

import { __extends, __spreadArray } from '../../_virtual/_tslib.js';
import React__default, { createRef } from 'react';
import ReactDOM from 'react-dom';
import styles from './fullScreenModal.module.css.js';
import IconArrowLeft from './icons/IconArrowLeft.js';
import IconCheck from './icons/IconCheck.js';
import IconClose from './icons/IconClose.js';
import IconClose2 from './icons/IconClose2.js';
import { transformToLatin } from '../../Utils/helpers.js';

var FullScreenModalMode;
(function (FullScreenModalMode) {
    FullScreenModalMode[FullScreenModalMode["Single"] = 0] = "Single";
    FullScreenModalMode[FullScreenModalMode["Multiple"] = 1] = "Multiple";
})(FullScreenModalMode || (FullScreenModalMode = {}));
var FullScreenModal = /** @class */ (function (_super) {
    __extends(FullScreenModal, _super);
    function FullScreenModal(props) {
        var _this = _super.call(this, props) || this;
        _this.isCheckedFocusOnScroll = false;
        _this.isTouchedOptionList = false;
        _this.state = {
            keyword: '',
            isShowLimitAlert: false
        };
        _this._bindMethods();
        _this.inputRef = createRef();
        _this.optionContainerRef = createRef();
        return _this;
    }
    FullScreenModal.prototype._bindMethods = function () {
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
        this.handleOnClickCloseAlert = this.handleOnClickCloseAlert.bind(this);
        this._clearKeywordInput = this._clearKeywordInput.bind(this);
        this.handleOnScroll = this.handleOnScroll.bind(this);
        this.handleOnTouch = this.handleOnTouch.bind(this);
    };
    FullScreenModal.prototype._clearKeywordInput = function () {
        this.setState({ keyword: '' });
    };
    FullScreenModal.prototype.componentDidMount = function () {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.optionContainerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', this.handleOnScroll);
        (_d = (_c = this.optionContainerRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.addEventListener('touchstart', this.handleOnTouch);
        (_f = (_e = this.optionContainerRef) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.addEventListener('touchend', this.handleOnTouch);
    };
    FullScreenModal.prototype.componentDidUpdate = function (prevProps) {
        var _a, _b;
        if (!prevProps.isOpen && this.props.isOpen) {
            (_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
            this.isCheckedFocusOnScroll = false;
        }
    };
    FullScreenModal.prototype.componentWillUnmount = function () {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = this.optionContainerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('scroll', this.handleOnScroll);
        (_d = (_c = this.optionContainerRef) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('touchstart', this.handleOnTouch);
        (_f = (_e = this.optionContainerRef) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.removeEventListener('touchend', this.handleOnTouch);
    };
    FullScreenModal.prototype.handleOnScroll = function () {
        var _a, _b;
        var isFocusAndScroll = (document === null || document === void 0 ? void 0 : document.hasFocus()) && !this.isCheckedFocusOnScroll && this.isTouchedOptionList;
        if (isFocusAndScroll) {
            (_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.blur();
            this.isCheckedFocusOnScroll = true;
        }
    };
    FullScreenModal.prototype.handleOnTouch = function (event) {
        if (event.type === 'touchstart') {
            this.isTouchedOptionList = true;
        }
        if (event.type === 'touchend') {
            this.isTouchedOptionList = false;
        }
    };
    FullScreenModal.prototype.handleKeywordChange = function (event) {
        var value = event.target.value;
        this.setState({ keyword: value });
    };
    FullScreenModal.prototype.handleOnClickCloseAlert = function () {
        this.setState({ isShowLimitAlert: false });
    };
    FullScreenModal.prototype.selectOption = function (option) {
        var _this = this;
        var canSelect = true;
        if (this.props.mode === FullScreenModalMode.Multiple && this.props.limit !== undefined) {
            // multi select and have set limit
            var selectedOptionList = __spreadArray([], this.props.selectedOptionId, true);
            if (selectedOptionList.length >= this.props.limit) {
                canSelect = false;
            }
            // Check if is de-select item
            if (selectedOptionList.includes(option.id)) {
                // is de-select so it canSelect
                canSelect = true;
            }
        }
        if (canSelect) {
            this._clearKeywordInput();
            this.props.onOptionSelected(option);
        }
        else {
            // show toast alert at bottom
            this.setState({ isShowLimitAlert: true });
            setTimeout(function () { return _this.setState({ isShowLimitAlert: false }); }, 3000);
        }
    };
    FullScreenModal.prototype.render = function () {
        var _this = this;
        var _a = this.state, keyword = _a.keyword, isShowLimitAlert = _a.isShowLimitAlert;
        var _b = this.props, isOpen = _b.isOpen, selectedOptionId = _b.selectedOptionId, limitAlertText = _b.limitAlertText;
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (bodyNode) {
            // Render the list of options
            var optionListNode = this.props.options
                .filter(function (option) {
                // Filter only the options that match our keyword
                var optionNameInLatin = transformToLatin(option.name);
                var keywordInLatin = transformToLatin(keyword);
                return optionNameInLatin.includes(keywordInLatin);
            })
                .map(function (option) {
                // Map filtered options to JSX options
                var isSelected = false;
                var _key = "option-".concat(option.id);
                if (_this.props.mode === FullScreenModalMode.Single) {
                    isSelected = selectedOptionId === option.id;
                }
                else {
                    if (typeof selectedOptionId === 'object') {
                        var _arrayValue = selectedOptionId;
                        _key = "".concat(option.id, "-").concat(_arrayValue.join('_'), "-").concat(_arrayValue.length);
                        isSelected = _arrayValue.includes(option.id);
                    }
                    else {
                        isSelected = selectedOptionId === option.id;
                    }
                }
                return (React__default.createElement("div", { key: _key, onClick: function (event) {
                        event.stopPropagation();
                        _this.selectOption(option);
                    }, onMouseDown: function (event) {
                        event.stopPropagation();
                        event.nativeEvent.stopImmediatePropagation();
                    }, className: "".concat(styles.optionItem, " ").concat(isSelected ? styles.optionItemHighlighted : '') },
                    option.name,
                    isSelected ? React__default.createElement(IconCheck, null) : null));
            });
            // Render the Modal
            return ReactDOM.createPortal(React__default.createElement("div", { className: "".concat(styles.modalContainer, " ").concat(isOpen ? styles.modalContainerIsOpen : '', " ").concat(this.props.mode === FullScreenModalMode.Multiple ? styles.modalMultiple : '') },
                React__default.createElement("div", { className: styles.modalHeader },
                    React__default.createElement("div", { className: styles.inputWrapper },
                        React__default.createElement("input", { tabIndex: -1, value: keyword, onChange: this.handleKeywordChange, type: 'text', ref: this.inputRef, onFocus: function () { return (_this.isCheckedFocusOnScroll = false); } }),
                        React__default.createElement(IconArrowLeft, { onClick: this.props.onBack }),
                        keyword ? React__default.createElement(IconClose, { onClick: function () { return _this.setState({ keyword: '' }); } }) : null)),
                React__default.createElement("div", { className: styles.modalBody, ref: this.optionContainerRef }, optionListNode),
                React__default.createElement("div", { className: isShowLimitAlert ? styles.limitAlert + ' ' + styles.limitAlertActive : styles.limitAlert },
                    React__default.createElement("span", { className: styles.limitAlertContent },
                        React__default.createElement("span", { className: styles.limitAlertContentText }, limitAlertText),
                        React__default.createElement("span", { className: styles.limitAlertCloseIcon, onClick: this.handleOnClickCloseAlert },
                            React__default.createElement(IconClose2, null))))), bodyNode);
        }
        return null;
    };
    FullScreenModal.defaultProps = {
        isOpen: false,
        options: [{ id: -1, name: 'All options' }],
        onOptionSelected: function () {
            console.info('Option selected, no handler bound!');
        },
        onBack: function () {
            console.info('Backed, no handler bound!');
        },
        selectedOptionId: -1,
        mode: FullScreenModalMode.Single,
        limit: -1,
        limitAlertText: ''
    };
    return FullScreenModal;
}(React__default.PureComponent));

export { FullScreenModalMode, FullScreenModal as default };
//# sourceMappingURL=index.js.map
